import { render, staticRenderFns } from "./PrivacyPolicyCpt.vue?vue&type=template&id=18c32c13&scoped=true&"
import script from "./PrivacyPolicyCpt.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPolicyCpt.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyPolicyCpt.vue?vue&type=style&index=0&id=18c32c13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c32c13",
  null
  
)

export default component.exports